import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { IChatConversation } from '@fi-shared/fi-chat/fi-chat';

@Component({
    selector: 'fi-chat-rename-conversation-dialog',
    template: `
        <mat-form-field
            appearance="fill"
            class="conversation-new-name-input"
        >
            <mat-label>{{ 'chat.rename_placeholder' | fiAppText }}</mat-label>
            <input matInput [(ngModel)]="newConversationName" />
        </mat-form-field>
    `,
    styleUrls: ['./fi-chat-conversation-rename-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-rename-dialog' },
    standalone: false,
})
export class FiChatConversationRenameDialogComponent
    extends FiDialogsContentBase<IChatConversation, string>
    implements OnInit
{
    newConversationName = '';

    ngOnInit() {
        if (!this.data.IsDefaultName) this.newConversationName = this.data.Name;
    }

    isYesButtonDisabled(): boolean {
        return this.getResult().length === 0;
    }

    getResult(): string {
        return this.newConversationName.trim();
    }
}
